import { createReducer, createActions } from "reduxsauce";

const { Types, Creators } = createActions({
  getPayments: ["params"],
  setPayments: ["paymentsList", "listSize"],
  submitPrepaidDestiny: ["issuer"],
  submitPrepaidDestinyEnd: [],
  approvePayment: ["payload"],
  rejectPayment: ["payload"],
  updateStatePaymentApprove: ["isApproved"],
  // Nuevas acciones para aprobar is_approved via ACC
  approveIssuerPayment: ["payload"],
  approveIssuerPaymentSuccess: [],
  approveIssuerPaymentError: ["error"],
  clearApproveIssuerPaymentState: [],
  setIssuerPayments: [
    "issuerPaymentList",
    "paymentsList",
    "holidays",
    "isOverdue"
  ],
  setCampaignSelected: [
    "campaignSelected",
    "issuerPayment",
    "optionValue",
    "isOverdue",
    "overdueAmount",
    "isPartialOverdue"
  ],
  setOtherAmount: ["otherAmount"],
  payIssuerPayments: ["issuer"],
  payIssuerPaymentsEnd: [],
  fetchingEnd: [],
  setAmount: ["amount"],
  setShowState: ["showState"],
  setBanksList: ["banksList"],
  startMyPayments: [],
  downloadFileExcel: ["payload"],
  downloadAmortizationTable: ["payload"],
  getOverduePayments: ["campaignsIds"],
  setOverduePayments: ["overduePayments"]
});

export const PaymentsTypes = Types;
export default Creators;

const INITIAL_STATE = {
  isFetching: false,
  isLoading: false,
  paymentsList: [],
  issuerPaymentList: [],
  campaignSelected: 0,
  issuerPaymentSelected: {},
  otherAmount: 0,
  listSize: 0,
  showState: false,
  banksList: [],
  issuer: {},
  holidays: [],
  overduePayments: [],
  isPartialOverdue: false,
  // Estado para aprobar is_approved via ACC
  isApprovingIssuerPayment: false,
  approveIssuerPaymentError: null,
  isIssuerPaymentApproved: false
};

const payIssuerPayments = (state) => ({
  ...state,
  isFetching: true
});

const payIssuerPaymentsEnd = (state) => ({
  ...state,
  issuerPaymentSelected: {},
  isFetching: false
});

const fetchingEnd = (state) => ({
  ...state,
  isFetching: false
});

const submitPrepaidDestiny = (state) => ({ ...state, isFetching: true });

const submitPrepaidDestinyEnd = (state) => ({ ...state, isFetching: false });

const getPayments = (state) => ({
  ...state,
  isLoading: true
});

const startMyPayments = (state) => ({
  ...state,
  isLoading: true
});

const setPayments = (state, { paymentsList, listSize }) => ({
  ...state,
  paymentsList,
  listSize,
  isLoading: false
});

const approvePayment = (state) => ({
  ...state,
  isApproved: false
});

const rejectPayment = (state) => ({
  ...state,
  isApproved: false
});

const updateStatePaymentApprove = (state, { isApproved }) => ({
  ...state,
  isApproved
});

// Reducers para aprobar is_approved via ACC
const approveIssuerPayment = (state) => ({
  ...state,
  isIssuerPaymentApproved: false,
  isApprovingIssuerPayment: true,
  approveIssuerPaymentError: null
});

const approveIssuerPaymentSuccess = (state) => ({
  ...state,
  isIssuerPaymentApproved: true,
  isApprovingIssuerPayment: false,
  approveIssuerPaymentError: null
});

const approveIssuerPaymentError = (state, { error }) => ({
  ...state,
  isIssuerPaymentApproved: false,
  isApprovingIssuerPayment: false,
  approveIssuerPaymentError: error
});

const clearApproveIssuerPaymentState = (state) => ({
  ...state,
  isIssuerPaymentApproved: false,
  isApprovingIssuerPayment: false,
  approveIssuerPaymentError: null
});

const setIssuerPayments = (
  state,
  { issuerPaymentList, paymentsList, holidays, isOverdue = false }
) => ({
  ...state,
  issuerPaymentList,
  paymentsList,
  holidays,
  isLoading: isOverdue
});

const setCampaignSelected = (
  state,
  {
    campaignSelected,
    issuerPayment,
    isOverdue,
    overdueAmount,
    isPartialOverdue
  }
) => ({
  ...state,
  campaignSelected,
  issuerPaymentSelected: issuerPayment,
  isOverdue,
  overdueAmount,
  isPartialOverdue: isPartialOverdue || false,
  isLoading: false
});

const setOtherAmount = (state, { otherAmount }) => ({
  ...state,
  otherAmount,
  isLoading: false
});

const setAmount = (state, amount) => ({
  ...state,
  ...amount
});

const setShowState = (state, { showState }) => ({
  ...state,
  showState,
  isLoading: false
});

const setBanksList = (state, { banksList }) => ({
  ...state,
  banksList
});

const downloadFileExcel = (state, { payload }) => ({
  ...state,
  isLoading: payload.isLoading,
  campaignId: payload.campaignId
});

const downloadAmortizationTable = (state, { payload }) => ({
  ...state,
  isLoading: payload.isLoading,
  campaignId: payload.campaignId
});

const getOverduePayments = (state, { campaignsIds }) => ({
  ...state,
  overduePayments: [],
  isLoading: true,
  campaignsIds
});

const setOverduePayments = (state, { overduePayments }) => ({
  ...state,
  overduePayments,
  isLoading: false
});

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SUBMIT_PREPAID_DESTINY]: submitPrepaidDestiny,
  [Types.SUBMIT_PREPAID_DESTINY_END]: submitPrepaidDestinyEnd,
  [Types.GET_PAYMENTS]: getPayments,
  [Types.SET_PAYMENTS]: setPayments,
  [Types.APPROVE_PAYMENT]: approvePayment,
  [Types.REJECT_PAYMENT]: rejectPayment,
  [Types.UPDATE_STATE_PAYMENT_APPROVE]: updateStatePaymentApprove,
  [Types.APPROVE_ISSUER_PAYMENT]: approveIssuerPayment,
  [Types.APPROVE_ISSUER_PAYMENT_SUCCESS]: approveIssuerPaymentSuccess,
  [Types.APPROVE_ISSUER_PAYMENT_ERROR]: approveIssuerPaymentError,
  [Types.CLEAR_APPROVE_ISSUER_PAYMENT_STATE]: clearApproveIssuerPaymentState,
  [Types.SET_ISSUER_PAYMENTS]: setIssuerPayments,
  [Types.SET_CAMPAIGN_SELECTED]: setCampaignSelected,
  [Types.SET_OTHER_AMOUNT]: setOtherAmount,
  [Types.PAY_ISSUER_PAYMENTS]: payIssuerPayments,
  [Types.PAY_ISSUER_PAYMENTS_END]: payIssuerPaymentsEnd,
  [Types.FETCHING_END]: fetchingEnd,
  [Types.SET_AMOUNT]: setAmount,
  [Types.SET_SHOW_STATE]: setShowState,
  [Types.SET_BANKS_LIST]: setBanksList,
  [Types.START_MY_PAYMENTS]: startMyPayments,
  [Types.DOWNLOAD_FILE_EXCEL]: downloadFileExcel,
  [Types.DOWNLOAD_AMORTIZATION_TABLE]: downloadAmortizationTable,
  [Types.GET_OVERDUE_PAYMENTS]: getOverduePayments,
  [Types.SET_OVERDUE_PAYMENTS]: setOverduePayments
});
